"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignObj = assignObj;
exports.default = cascader;
exports.useRunCascader = useRunCascader;

var _lodash = require("lodash");

var _tools = require("./utils/tools");

var _expression = require("./utils/expression");

var _helper = require("./utils/helper");

var _render = require("./render");

var _action = require("./action");

/*
 * 合并两个对象的value和wprops属性
 * 以leftObj为主要对象，当rightObj中的属性不在leftObj时，把属性补充进去
*/
function assignObjWidth(letObj, rightObj) {
  if ((0, _tools.isObject)(letObj) && (0, _tools.isObject)(rightObj)) {
    if (letObj.value === undefined) {
      letObj.value = rightObj.value;
    }

    if (letObj.wprops === undefined) {
      letObj.wprops = rightObj.wprops;
    } else if ((0, _tools.isObject)(letObj.wprops) && (0, _tools.isObject)(rightObj.wprops)) {
      Object.keys(rightObj.wprops).forEach(function (key) {
        if (!(key in letObj.wprops)) {
          letObj.wprops[key] = rightObj.wprops[key];
        }
      });
    }
  }
}

function assignObj(leftObj, rightObj) {
  if ((0, _tools.isObject)(leftObj) && (0, _tools.isObject)(rightObj)) {
    if (rightObj.value !== undefined) {
      leftObj.value = rightObj.value;
    }

    if (leftObj.wprops === undefined) {
      leftObj.wprops = rightObj.wprops;
    } else if ((0, _tools.isObject)(leftObj.wprops) && (0, _tools.isObject)(rightObj.wprops)) {
      Object.keys(rightObj.wprops).forEach(function (key) {
        leftObj.wprops[key] = rightObj.wprops[key];
      });
    }
  }
}

function resolvePath(expression, currentDataBinds) {
  if (typeof expression === 'string') {
    return expression.replace(/\/\./g, function () {
      if (Array.isArray(currentDataBinds) && currentDataBinds.length > 0) {
        return "".concat((0, _helper.pathsToString)(currentDataBinds), ".");
      }

      return '';
    });
  }

  return expression;
} // 联动


function cascader(cascadeOn, options) {
  var formData = options.formData,
      parentDataBinds = options.parentDataBinds,
      dataProxy = options.dataProxy,
      optionsDefaultData = options.defaultData;
  var defaultData = (0, _lodash.cloneDeep)(optionsDefaultData);
  var hasChange = false;

  if ((0, _tools.isObject)(cascadeOn)) {
    var cascadeValue = '';
    Object.keys(cascadeOn).map(function (key) {
      cascadeValue = cascadeOn[key];

      if (!Array.isArray(cascadeValue)) {
        cascadeValue = [cascadeValue];
      }

      switch (key) {
        // 隐藏组件
        case 'hidden':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath((item === null || item === void 0 ? void 0 : item.expression) || item, parentDataBinds), formData);

            if (!!dataProxy.hidden !== result.result) {
              dataProxy.hidden = !dataProxy.hidden;
              hasChange = true;
            }
          });
          break;
        // 可见组件

        case 'visible':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath((item === null || item === void 0 ? void 0 : item.expression) || item, parentDataBinds), formData);

            if (!!dataProxy.hidden === result.result) {
              dataProxy.hidden = !dataProxy.hidden;
              hasChange = true;
            }
          });
          break;
        // 更新属性

        case 'update':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath(item.expression, parentDataBinds), formData);

            if (result.result) {
              hasChange = true; // 联动结果数据和当前联动预配置的数据合并

              assignObjWidth(result, item); // 联动结果数据和代理对象合并

              assignObj(dataProxy, result);
            }
          });
          break;
        // 替换属性

        case 'replace':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath(item.expression, parentDataBinds), formData);

            if (result.result) {
              hasChange = true;
              assignObj(result, item);

              if (result.value !== undefined) {
                dataProxy.value = result.value;
              }

              if ((0, _tools.isObject)(result.wprops)) {
                dataProxy.wprops = result.wprops;
              }
            }
          });
          break;
        // 重置属性

        case 'reset':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath(item.expression, parentDataBinds), formData);

            if (result.result) {
              hasChange = true;
              dataProxy.value = defaultData === null || defaultData === void 0 ? void 0 : defaultData.value;
              dataProxy.wprops = defaultData === null || defaultData === void 0 ? void 0 : defaultData.wprops;
            }
          });
          break;
        // 重置属性

        case 'action':
          cascadeValue.forEach(function (item) {
            var result = (0, _expression.runExpression)(resolvePath(item.expression, parentDataBinds), formData);

            if (result.result) {
              (0, _action.runActions)(item.action, options);
            }
          });
          break;

        default:
          break;
      }

      return key;
    });
  }

  return hasChange;
}

function useRunCascader(cascadeOn) {
  var _useUtils = (0, _render.useUtils)(),
      getDataProxy = _useUtils.getDataProxy,
      getDefaultData = _useUtils.getDefaultData,
      getParentDataBinds = _useUtils.getParentDataBinds,
      getNameMap = _useUtils.getNameMap,
      getFormData = _useUtils.getFormData;

  var dataProxy = getDataProxy();
  var formData = getFormData();
  var defaultData = getDefaultData();
  var nameMap = getNameMap();
  var parentDataBinds = getParentDataBinds();

  if (dataProxy) {
    cascader(cascadeOn, {
      dataProxy: dataProxy,
      parentDataBinds: parentDataBinds,
      formData: formData,
      nameMap: nameMap,
      defaultData: defaultData
    });
  } else {
    console.warn('!!禁止在根级调用此联动方法，建议直接使用cascader');
  }
}